import { TableHeader } from '@/components/ui/table';

export function AvgContainerTagHeader() {
  return (
    <TableHeader narrow className="text-left align-bottom">
      Average
      <br />
      Container TAG
    </TableHeader>
  );
}
